/**
 * Storage module
 * 
 * This file provides platform-specific storage implementations:
 * - On mobile, it uses MMKV (storage.ts)
 * - On web, it uses localStorage (storage.web.ts)
 * 
 * The React Native bundler automatically selects the right implementation
 * based on the platform.
 */

export * from './storage'; 